export const TOP_PERFORMERS_WIDGET = {
  ACTION_TYPES: {
    displayHandler: 'displayHandler',
  }
};
